import React, { useState } from 'react';
import { CheckCircle, ChevronDown, Edit3, RefreshCw, Send, XCircle } from 'lucide-react';

/** @param {{entry:any, onStatusUpdate:(id:string,action:string,comment?:string,assignee?:string)=>void, userRole:string, teamMembers?:Array}} props */
export default function WorkflowActions({ entry, onStatusUpdate, userRole, teamMembers }) {
  const [show, setShow] = useState(false);
  const [assignee, setAssignee] = useState('');
  const [comment, setComment] = useState('');

  const actions = (() => {
    const a = [];
    switch (entry.status) {
      case 'draft':
        a.push({ action: 'submitted', label: 'Submit for Review', color: 'blue', Icon: Send });
        break;
      case 'submitted':
        if (['admin','manager'].includes(userRole)) {
          a.push({ action: 'approved', label: 'Approve', color: 'green', Icon: CheckCircle });
          a.push({ action: 'rejected', label: 'Reject', color: 'red', Icon: XCircle });
        }
        break;
      case 'in_review':
        if (['admin','manager'].includes(userRole)) {
          a.push({ action: 'approved', label: 'Approve', color: 'green', Icon: CheckCircle });
          a.push({ action: 'rejected', label: 'Reject', color: 'red', Icon: XCircle });
          a.push({ action: 'submitted', label: 'Send Back', color: 'yellow', Icon: RefreshCw });
        }
        break;
      case 'rejected':
        a.push({ action: 'draft', label: 'Move to Draft', color: 'gray', Icon: Edit3 });
        break;
    }
    return a;
  })();

  if (actions.length === 0) return null;

  const handle = (action) => {
    onStatusUpdate(entry.id, action, comment, assignee);
    setComment(''); setAssignee(''); setShow(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShow(!show)}
        className="flex items-center space-x-1 px-3 py-1.5 text-sm bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors"
      >
        <RefreshCw className="w-4 h-4" />
        <span>Workflow</span>
        <ChevronDown className="w-4 h-4" />
      </button>

      {show && (
        <div className="absolute right-0 top-10 bg-white border border-slate-200 rounded-lg shadow-lg z-20 p-4 min-w-80">
          <h4 className="font-medium text-slate-800 mb-3">Update Status</h4>
          <div className="space-y-2 mb-4">
            {actions.map(({ action, label, color, Icon }) => (
              <button
                key={action}
                onClick={() => handle(action)}
                className={`w-full flex items-center space-x-2 px-3 py-2 rounded-lg text-sm transition-colors ${
                  color === 'blue' ? 'bg-blue-50 text-blue-700 hover:bg-blue-100' :
                  color === 'green' ? 'bg-green-50 text-green-700 hover:bg-green-100' :
                  color === 'red' ? 'bg-red-50 text-red-700 hover:bg-red-100' :
                  color === 'yellow' ? 'bg-yellow-50 text-yellow-700 hover:bg-yellow-100' :
                  'bg-gray-50 text-gray-700 hover:bg-gray-100'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span>{label}</span>
              </button>
            ))}
          </div>

          <div className="mb-3">
            <label className="block text-sm font-medium text-slate-700 mb-1">Add Comment (Optional)</label>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Add a note about this status change..."
              className="w-full px-3 py-2 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows={2}
            />
          </div>

          {['admin','manager'].includes(userRole) && teamMembers?.length > 0 && (
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Assign to Reviewer</label>
              <select
                value={assignee}
                onChange={(e) => setAssignee(e.target.value)}
                className="w-full px-3 py-2 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select reviewer...</option>
                {teamMembers.map(m => (
                  <option key={m.user_id} value={m.user_id}>
                    {m.full_name || m.email} ({m.role})
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
